/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Image_jsonld } from './Image_jsonld';
import type { TileFeatures_jsonld } from './TileFeatures_jsonld';
import type { TileListing_jsonld } from './TileListing_jsonld';
import type { TileLocation_jsonld } from './TileLocation_jsonld';
import type { TileRate_jsonld } from './TileRate_jsonld';
import type { TileRating_jsonld } from './TileRating_jsonld';
export type ListingTile_jsonld = {
    readonly '@context'?: string | Record<string, any>;
    readonly '@id'?: string;
    readonly '@type'?: string;
    id?: string;
    name?: string;
    source?: ListingTile_jsonld.source;
    rating?: TileRating_jsonld;
    location?: TileLocation_jsonld;
    features?: TileFeatures_jsonld;
    images?: Array<Image_jsonld>;
    path?: string;
    rate?: TileRate_jsonld | null;
    foreignPartnerId?: number | null;
    listing?: TileListing_jsonld;
};
export namespace ListingTile_jsonld {
    export enum source {
        NOC = 'noc',
        NOP = 'nop',
    }
}
